import axios from 'axios';
import { Config } from '../config';
import userStore from "../store/userStore";
import { setStage } from '../action/userActions';
import getHeaders from './header';

/** Manages the stage object for stage progress inside the application. */
export default class StageManager {
    constructor() {
        this.stages = [
            {
                name: '1. Creating a site structure',
                desc: 'A Site Tree is being created by us.',
            },
            {
                name: '2. Site structure completed',
                desc: 'A Site Tree  has been created and is ready to be viewed.',
                actions: [
                    { text: 'View Tree', actionObj: { loc: '/tree', state: {} } }
                ]
            },
            {
                name: '3. Mapping data sources to targets',
                desc: 'You can now match your file shares with the Document Libraries defined in the site Tree.',
                actions: [
                    { text: 'Go to Tree', actionObj: { loc: '/tree', state: {} } }
                ]
            },
            {
                name: '4. Awaiting sign-off for the initial Site Tree',
                desc: 'View your Site Tree and let us know if it is correct',
                actions: [
                    { text: 'Accept', variant: 'success', actionObj: { loc: '/acceptrejectstage', state: { type: 'accepted', stage: 3 } } },
                    { text: 'Reject', variant: 'danger', actionObj: { loc: '/acceptrejectstage', state: { type: 'rejected', stage: 3 } } }
                ],
                accepted: {
                    desc: 'Please enter any feedback on the Site Tree and Submit.  Accepting will move the status on.'
                },
                rejected: {
                    desc: 'Please tell us why you are rejecting the Site Tree.  Status will remain unchanged.'
                }
            },
            {
                name: '5. Creating a demo site',
                desc: 'We are creating a demo site for you to see what your live site will look like.'
            },
            {
                name: '6. Demo Site Created. Awaiting Approval',
                desc: 'We need your approval on the demo site.',
                actions: [
                    { text: 'View Demo Site', actionObj: { loc: '/demosite', state: { type: 'demo', stage: 5 } } },
                    { text: 'Accept', variant: 'success', actionObj: { loc: '/acceptrejectstage', state: { type: 'accepted', stage: 5 } } },
                    { text: 'Reject', variant: 'danger', actionObj: { loc: '/acceptrejectstage', state: { type: 'rejected', stage: 5 } } },
                ],
                accepted: {
                    desc: 'Please enter any feedback on the Demo Site and Submit.  Accepting will move the status on.'
                },
                rejected: {
                    desc: 'Please tell us why you are rejecting the Demo Site.  Status will remain unchanged.'
                },
                demo: {
                    desc: 'Below are your login details to the demo SharePoint site.'
                }
            },
            {
                name: '7. Preparing training documents',
                desc: 'We are preparing the training documentation for your new site.'
            },
            {
                name: '8. Awaiting final migration',
                desc: 'We are migrating your files to Document Libraries.'
            },
            {
                name: '9. Migration Completed',
                desc: 'We have completed migration of your files.',
                actions: [
                    { text: 'View Live Site', actionObj: { loc: '/livesite', state: { type: 'livesite', stage: 8 } } }
                ],
                livesite: {
                    desc: 'You can view your live site using your existing user details at:- '
                }
            },
            {
                name: '10. Project completed, awaiting sign-off',
                desc: 'Let us know if the site is correct and finished.',
                actions: [
                    { text: 'Accept', variant: 'success', actionObj: { loc: '/acceptrejectstage', state: { type: 'accepted', stage: 9 } } },
                    { text: 'Reject', variant: 'danger', actionObj: { loc: '/acceptrejectstage', state: { type: 'rejected', stage: 9 } } }
                ],
                accepted: {
                    desc: 'Please enter any feedback you have on the Live Site.  Accepting will move the status on.'
                },
                rejected: {
                    desc: 'Please tell us why you are rejecting the Live Site.  Status will remain unchanged.'
                }
            },
            {
                name: '11. Site Accepted',
                desc: 'You have accepted the site at:-',
                actions: [
                    { text: 'View Live Site', actionObj: { loc: '/livesite', state: { type: 'livesite', stage: 10 } } }
                ],
                livesite: {
                    desc: 'Your live site is available at:- '
                }
            }
        ];
        this.urlStarter = Config[Config.env].functionappurl;
    }

    // Return the stage array
    getAllStages() {
        return this.stages;
    }

    getStageByIndex(index) {
        return this.stages[index];
    }

    /**
     * grabs the company stage of the user logged in
     * @todo i dont think it has use anymore
     */
    getCompanyStage() {
        return new Promise(async(resolve, reject) => {
            const url = this.urlStarter + "api/staging?getStage=" + userStore.user.company;
            const headers = await getHeaders();

            axios.get(url, { headers: headers }).then((response) => {
                setStage(response.data.stage);
                resolve();
            }).catch((e) => {
                reject(e);
            })
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/stageManager.js